module.exports = __webpack_public_path__ + "static/commando-4b17af917596449bcc8f178e5576fdcc.png";